export enum DoboxRuleApplyTarget {
  EMAIL = 'EMAIL',
  REAL_TIME_PLATFORMS = 'REAL_TIME_PLATFORMS',
}

export enum DoBoxRuleDecisionAction {
  CREATE = 'CREATE',
  MERGE = 'MERGE',
  REPLACE = 'REPLACE',
  SKIP = 'SKIP',
}

export interface DoBoxRule {
  userId: string; // PK
  id: string; // SK
  instructions: string;
  createdAt: number;
  active: boolean;
  updatedAt: number;
  category?: string;
  target?: DoboxRuleApplyTarget;
}

export interface DoBoxRuleDecision {
  action: DoBoxRuleDecisionAction;
  rule?: string;
  reason?: string;
  targetId?: string;
}
